module.exports = __webpack_public_path__ + "img/d79376b8457c3a8f0d55098cc3f8fde0.jpg";